import { useEffect, useRef } from 'react';

export const useDidMountEffect = (
    func: (prevDeps: Array<any>) => void,
    deps: Array<any>,
) => {
    const didMount = useRef(false);
    const prevState = useRef<any>(deps);

    useEffect(() => {
        if (didMount.current) {
            func(prevState.current);
        } else didMount.current = true;

        prevState.current = deps;
    }, [deps, func]);
};
